// ---
// Free shipping bonus: adiciona produtos bônus ao carrinho ao atingir metas
// e remove quando o valor recua. Identificador: propriedade _bonus_goal = "1"|"2"|"3"|"4"
// Também atualiza a mensagem e o progresso da barra de frete grátis sem recarregar a página.
//
// 03/11/2026 — otimização de performance: a sincronização deixou de rodar a cada 1,5 s
// (setInterval) e passou a rodar só quando o carrinho muda (chamadas a /cart/add,
// /cart/change, /cart/update, /cart/clear, eventos do tema) + uma verificação de
// segurança a cada 30 s apenas com a aba visível. O comportamento visível é o mesmo.
// 04/11/2026 — trava: remove automaticamente os adicionais (-ADD/-PROMO/-POS) se o carrinho ficar sem
// produto principal (ou abaixo de R$ 80 no caso da variante preço especial).
// ---
(function () {
var BONUS_PROP = '_bonus_goal';
var FALLBACK_INTERVAL_MS = 30000;
var DEBOUNCE_MS = 350;
var BAR_SELECTOR = 'free-shipping-bar';
var BAR_DISPLAY_CONFIG_ATTR = 'data-bar-display-config';
var BAR_MESSAGE_SELECTOR = '[data-free-shipping-bar-message]';
var BAR_PROGRESS_DOTS_SELECTOR = '[data-free-shipping-progress-bar-dots]';
var LOADING_HIDE_DELAY_MS = 2800;
var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
// Trava dos adicionais de checkout (SKUs terminados em -ADD, -PROMO ou -POS, ex.: 2CO-PROMO):
// só podem ficar no carrinho junto com produtos normais; a variante "preço especial"
// (-PROMO) exige R$ 80 de produtos normais.
var ADDON_SKU_RE = /-(ADD|PROMO|POS)$/i;
var ADDON_SPECIAL_SKU_RE = /-PROMO$/i;
var ADDON_VIP_MIN_CENTS = 8000;

var syncTimer = null;
var syncing = false;
var pendingAgain = false;

function getConfig() {
var el = document.querySelector('[data-bonus-config]');
if (!el || !el.getAttribute('data-bonus-config')) return [];
try {
var raw = el.getAttribute('data-bonus-config');
if (!raw || raw === '[]') return [];
return JSON.parse(raw);
} catch (e) {
return [];
}
}

function fetchCart() {
return fetch('/cart.js').then(function (r) { return r.json(); });
}

function goalsReached(cartTotal, goals) {
return goals.filter(function (g) { return cartTotal >= g.cents; }).map(function (g) { return String(g.goal); });
}

function bonusItemsInCart(cart) {
return (cart.items || []).filter(function (item) {
return item.properties && item.properties[BONUS_PROP];
});
}

function formatMoney(cents, currency) {
try {
var code = (currency || 'BRL').toUpperCase();
return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: code }).format(cents / 100);
} catch (e) {
return (cents / 100).toFixed(2).replace('.', ',') + ' ' + (currency || 'BRL');
}
}

function getBarDisplayConfig(barEl) {
var raw = barEl.getAttribute(BAR_DISPLAY_CONFIG_ATTR);
if (!raw) return null;
try {
return JSON.parse(raw.replace(/&#39;/g, "'"));
} catch (e) {
return null;
}
}

function updateBarFromCart(barEl, cart) {
var config = getBarDisplayConfig(barEl);
if (!config || !config.goals || !config.goals.length) return;
var cartTotal = cart.total_price;
var maxGoalCents = config.maxGoalCents || 100;
var goals = config.goals;
var nextGoalCents = null;
var nextReward = '';
for (var i = 0; i < goals.length; i++) {
if (cartTotal < goals[i].cents) {
nextGoalCents = goals[i].cents;
nextReward = goals[i].reward || '';
break;
}
}
var differencePercent = maxGoalCents > 0 ? Math.min(100, Math.round((cartTotal / maxGoalCents) * 100)) : 0;
var differenceStr = '';
var fullMessage = '';
if (nextGoalCents != null) {
var diff = nextGoalCents - cartTotal;
differenceStr = formatMoney(diff, cart.currency);
fullMessage = (config.template || '')
.replace('[value]', differenceStr)
.replace('[reward]', nextReward);
} else {
fullMessage = config.achieved || '';
differencePercent = 100;
}
barEl.setAttribute('data-free-shipping-difference', differenceStr);
barEl.setAttribute('data-free-shipping-difference-percent', String(differencePercent));
barEl.setAttribute('data-progress-message', fullMessage);
var messageNode = barEl.querySelector(BAR_MESSAGE_SELECTOR);
var dotsNode = barEl.querySelector(BAR_PROGRESS_DOTS_SELECTOR);
if (messageNode) {
messageNode.textContent = fullMessage;
}
if (dotsNode) {
dotsNode.setAttribute('style', '--gsc-freeshipping-bar-percent: ' + differencePercent + '%');
}
}

function updateAllBars(cart) {
var bars = document.querySelectorAll(BAR_SELECTOR);
for (var i = 0; i < bars.length; i++) {
updateBarFromCart(bars[i], cart);
}
}

function setCartLoading(loading) {
var drawer = document.querySelector('cart-drawer');
var page = document.querySelector('cart-page');
if (drawer && typeof drawer.setLoadingStatus === 'function') {
drawer.setLoadingStatus(loading);
}
if (page && typeof page.setLoadingStatus === 'function') {
page.setLoadingStatus(loading);
}
}

function refreshCartDrawer() {
var cartDrawer = document.querySelector('cart-drawer');
if (cartDrawer && typeof cartDrawer.update === 'function') {
cartDrawer.update();
}
}

function refreshCartPage() {
var cartPage = document.querySelector('cart-page');
if (!cartPage || !window.routes || !window.routes.cart_url) return;
var sectionId = cartPage.dataset.sectionId;
if (!sectionId) return;
var url = window.routes.cart_url + '?sections=' + encodeURIComponent(sectionId);
fetch(url)
.then(function (r) { return r.json(); })
.then(function (data) {
if (!data.sections || !data.sections[sectionId]) return;
var html = data.sections[sectionId];
var parser = new DOMParser();
var doc = parser.parseFromString(html, 'text/html');
var node = doc.body && doc.body.firstElementChild;
if (node && typeof cartPage.purchaseHandler === 'function') {
cartPage.purchaseHandler(node, {});
}
})
.catch(function () {});
}

function refreshCartUI() {
refreshCartDrawer();
if (document.querySelector('cart-page')) {
refreshCartPage();
}
}

function isAddon(item) {
return !!(item.sku && ADDON_SKU_RE.test(String(item.sku)));
}

function addonsToRemove(cart) {
var items = cart.items || [];
var baseCents = 0;
items.forEach(function (item) {
if (!isAddon(item) && !(item.properties && item.properties[BONUS_PROP])) {
baseCents += item.original_line_price || item.line_price || 0;
}
});
return items.filter(function (item) {
if (!isAddon(item)) return false;
if (baseCents <= 0) return true;
var vip = ADDON_SPECIAL_SKU_RE.test(String(item.sku));
return vip && baseCents < ADDON_VIP_MIN_CENTS;
});
}

function removeAddons(items) {
var chain = Promise.resolve();
items.forEach(function (item) {
chain = chain.then(function () {
return fetch('/cart/change.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ id: item.key, quantity: 0 })
}).then(function (r) { return r.json(); }).catch(function () {});
});
});
return chain;
}

function runSync() {
var config = getConfig();
var needsBarUpdate = document.querySelector(BAR_SELECTOR + '[' + BAR_DISPLAY_CONFIG_ATTR + ']') != null;

return fetchCart().then(function (cart0) {
var bad = addonsToRemove(cart0);
if (!bad.length) return cart0;
setCartLoading(true);
return removeAddons(bad).then(fetchCart).then(function (cart1) {
cart1.__addonsRemoved = true;
return cart1;
});
}).then(function (cart) {
var addonsRemoved = !!cart.__addonsRemoved;
if (needsBarUpdate) {
updateAllBars(cart);
}
if (!config.length) {
if (addonsRemoved) {
refreshCartUI();
setTimeout(function () { setCartLoading(false); }, LOADING_HIDE_DELAY_MS);
}
return Promise.resolve(addonsRemoved);
}

var cartTotal = cart.total_price;
var shouldHave = goalsReached(cartTotal, config);
var bonusItems = bonusItemsInCart(cart);

var toRemove = bonusItems.filter(function (item) {
var goal = String(item.properties[BONUS_PROP]);
return shouldHave.indexOf(goal) === -1;
});

var inCartByGoal = {};
bonusItems.forEach(function (item) {
inCartByGoal[String(item.properties[BONUS_PROP])] = true;
});
var toAdd = config.filter(function (g) {
return cartTotal >= g.cents && !inCartByGoal[String(g.goal)];
});

var cartWillChange = toRemove.length > 0 || toAdd.length > 0 || addonsRemoved;
if (cartWillChange) {
setCartLoading(true);
}

var chain = Promise.resolve();

toRemove.forEach(function (item) {
chain = chain.then(function () {
return fetch('/cart/change.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ id: item.key, quantity: 0 })
}).then(function (r) { return r.json(); }).catch(function () {});
});
});

toAdd.forEach(function (g) {
chain = chain.then(function () {
return fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({
items: [{
id: g.variant_id,
quantity: 1,
properties: { _bonus_goal: String(g.goal) }
}]
})
}).then(function (r) { return r.json(); }).catch(function () {});
});
});

return chain.then(function () {
if (cartWillChange) {
refreshCartUI();
setTimeout(function () {
setCartLoading(false);
}, LOADING_HIDE_DELAY_MS);
}
if (needsBarUpdate) {
return fetchCart().then(updateAllBars).then(function () { return cartWillChange; });
}
return cartWillChange;
});
});
}

function scheduleSync() {
if (syncing) { pendingAgain = true; return; }
syncing = true;
runSync().then(function (changed) {
if (changed && typeof window.dispatchEvent === 'function') {
try {
window.dispatchEvent(new CustomEvent('cart:refresh'));
} catch (e) {}
}
}).catch(function () {}).then(function () {
syncing = false;
if (pendingAgain) {
pendingAgain = false;
requestSync();
}
});
}

// Agrupa vários gatilhos próximos em uma única sincronização.
function requestSync() {
if (syncTimer) clearTimeout(syncTimer);
syncTimer = setTimeout(function () {
syncTimer = null;
scheduleSync();
}, DEBOUNCE_MS);
}

// Dispara a sincronização quando o próprio tema (ou outro script) altera o carrinho.
function watchCartMutations() {
if (!window.fetch || window.__fsBonusFetchPatched) return;
window.__fsBonusFetchPatched = true;
var originalFetch = window.fetch;
window.fetch = function (input, init) {
var url = '';
try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
var p = originalFetch.apply(this, arguments);
if (CART_MUTATION_RE.test(url)) {
p.then(function () { requestSync(); }, function () {});
}
return p;
};
if (window.XMLHttpRequest) {
var origOpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function (method, url) {
try {
if (CART_MUTATION_RE.test(String(url))) {
this.addEventListener('loadend', function () { requestSync(); });
}
} catch (e) {}
return origOpen.apply(this, arguments);
};
}
['cart:updated', 'cart:change', 'cart-drawer:open', 'cart:open'].forEach(function (evt) {
window.addEventListener(evt, requestSync);
document.addEventListener(evt, requestSync);
});
document.addEventListener('visibilitychange', function () {
if (document.visibilityState === 'visible') requestSync();
});
}

function start() {
watchCartMutations();
scheduleSync();
setInterval(function () {
if (document.visibilityState === 'visible') scheduleSync();
}, FALLBACK_INTERVAL_MS);
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', start);
} else {
start();
}
})();
